module.exports = __webpack_public_path__ + "assets/images/boundaries/keys-six-members/key-amk/key-1.svg?v=a773a560";